import React from 'react';

type IconDartProps = React.SVGProps<SVGSVGElement>;

const IconDart = (styles: IconDartProps) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...styles}>
    <g clip-path="url(#clip0_2131_12775)">
      <path
        d="M6.12 23.8799L0.96 18.7199C0.36 18.1199 0 17.2199 0 16.3799C0 15.9599 0.24 15.3599 0.42 14.9999L5.16 5.15991L6.12 23.8799Z"
        fill="#01579B"
      />
      <path
        d="M23.7 6.12L18.54 0.96C18.12 0.54 17.16 0 16.38 0C15.72 0 15.06 0.12 14.58 0.42L5.16 5.16L23.7 6.12Z"
        fill="#40C4FF"
      />
      <path d="M12.24 30H24.66V24.66L15.42 21.72L6.89999 24.66L12.24 30Z" fill="#40C4FF" />
      <path
        d="M5.16 21.1199C5.16 22.6799 5.34 23.0999 6.12 23.8799L6.9 24.6599H24.66L15.96 14.8199L5.16 5.15991V21.1199Z"
        fill="#29B6F6"
      />
      <path
        d="M20.94 5.15991H5.16L24.72 24.7199H30V12.4199L23.7 6.11991C22.8 5.21991 22.02 5.15991 20.94 5.15991Z"
        fill="#01579B"
      />
      <path
        opacity="0.2"
        d="M6.3 24.0599C5.52 23.2799 5.34 22.4999 5.34 21.1199V5.33991L5.16 5.15991V21.1199C5.16 22.4999 5.16 22.8599 6.3 24.0599L6.9 24.6599L6.3 24.0599Z"
        fill="white"
      />
      <path opacity="0.2" d="M29.82 12.24V24.48H24.48L24.66 24.66H30V12.42L29.82 12.24Z" fill="#263238" />
      <path
        opacity="0.2"
        d="M23.7 6.11991C22.74 5.15991 21.9 5.15991 20.76 5.15991H5.16L5.34 5.33991H20.76C21.3 5.33991 22.8 5.21991 23.7 6.11991Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M29.82 12.24L23.7 6.12L18.54 0.96C18.12 0.54 17.16 0 16.38 0C15.72 0 15.06 0.12 14.58 0.42L5.16 5.16L0.42 15C0.24 15.36 0 15.96 0 16.38C0 17.22 0.36 18.12 0.96 18.72L5.7 23.4C5.82 23.52 5.94 23.7 6.12 23.82L6.3 24L6.9 24.6L12.06 29.76L12.24 29.94H24.48H24.66V24.6H30V12.42L29.82 12.24Z"
        fill="url(#paint0_radial_2131_12775)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_2131_12775"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.9997 14.9999) scale(14.9998)"
      >
        <stop stop-color="white" stop-opacity="0.1" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <clipPath id="clip0_2131_12775">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconDart;
